import dayjs from "dayjs";
import type {
  APIListingAgentUpdateEntry,
  APIListingApplicantFeedbackEntry,
  APIListingEventFeedbackEntry,
} from "models/types/api-listing";
import { CardRecordMeta } from "components/cards/card-record-meta";
import { FooterText } from "modules/vendor-portal/screens/overview/components/feedback/footer/footer-text";
import { dateFormats } from "utils/date";

type AgentVendorFooterProps = {
  feedback:
    | APIListingAgentUpdateEntry
    | APIListingEventFeedbackEntry
    | APIListingApplicantFeedbackEntry;
};

export function AgentVendorFooter({ feedback }: AgentVendorFooterProps) {
  if (!("date_of" in feedback)) {
    return null;
  }

  return (
    <CardRecordMeta>
      <FooterText
        text={dayjs(feedback.date_of).format(dateFormats.dayMonthYear)}
      />
    </CardRecordMeta>
  );
}
